import * as GC from '@grapecity/spread-sheets';
import { IAggregationErrors } from '@models/import/poll-file-import';
import { mapActionKeys } from '@shared/spread/spread-action-keys';
import { FONT_NAME, FONT_SIZE } from '@shared/spread/spread-settings';

export const aggregationErrorsWorkbookInit = args => {
  const spread: GC.Spread.Sheets.Workbook = args.spread;

  return spread;
};

const setSheetProtection = (sheet: GC.Spread.Sheets.Worksheet) => {
  sheet.suspendPaint();
  sheet.suspendEvent();
  // Lock spread sheet for changes
  sheet.options.isProtected = true;

  sheet.options.protectionOptions = {
    ...sheet.options.protectionOptions,
    allowSelectLockedCells: true,
    allowSelectUnlockedCells: true,
    allowSort: true,
    allowFilter: false,
    allowEditObjects: false,
    allowResizeRows: false,
    allowResizeColumns: true,
    allowDragInsertRows: false,
    allowDragInsertColumns: false,
    allowInsertRows: false,
    allowInsertColumns: false,
    allowDeleteRows: false,
    allowDeleteColumns: false
  };

  sheet.options.clipBoardOptions = GC.Spread.Sheets.ClipboardPasteOptions.all;

  // Locking sheet for changes
  sheet.getRange(0, 0, sheet.getRowCount(), sheet.getColumnCount(), GC.Spread.Sheets.SheetArea.viewport).locked(true);

  sheet.resumePaint();
  sheet.resumeEvent();
};

export const aggregationErrorsSetUpWorkbook = (spread: GC.Spread.Sheets.Workbook, sheet: GC.Spread.Sheets.Worksheet) => {
  sheet.suspendPaint();
  sheet.suspendEvent();

  // =========================
  //   General Sheet Options
  // =========================

  const page = 'Aggregation Errors';
  sheet.name(page);

  sheet.defaults.rowHeight = 20;
  sheet.defaults.colWidth = 100;
  spread.options.tabStripVisible = false;
  sheet.options.allowCellOverflow = true;
  spread.options.showHorizontalScrollbar = true;
  sheet.options.colHeaderVisible = true;
  // sheet.options.frozenlineColor = 'transparent';
  sheet.setColumnCount(6);

  setSheetProtection(sheet);

  // setGreenArea({ page, startRow: 1, startCol: 1, paddingRows: 1, paddingCols: 1 });
  mapActionKeys(spread, sheet, page);

  sheet.setActiveCell(0, 4);
  sheet.resumeEvent();
  sheet.resumePaint();
};

export const populateAggregationErrorsSpread = (
  sheet: GC.Spread.Sheets.Worksheet,
  aggregationErrors: IAggregationErrors[],
  importSource
) => {
  sheet.suspendPaint();
  sheet.suspendEvent();

  if (importSource && typeof importSource === 'object') {
    let str = '';
    importSource.forEach(element => {
      str += element + ' ';
    });
  }

  // Setting Titles
  sheet.getCell(0, 0, GC.Spread.Sheets.SheetArea.colHeader).text('Import Source');
  sheet.getCell(0, 1, GC.Spread.Sheets.SheetArea.colHeader).text('Import Step');
  sheet.getCell(0, 2, GC.Spread.Sheets.SheetArea.colHeader).text('Error Type');
  sheet.getCell(0, 3, GC.Spread.Sheets.SheetArea.colHeader).text('Sub Product ID');
  sheet.getCell(0, 4, GC.Spread.Sheets.SheetArea.colHeader).text('Error Text');

  // Populating Data
  if (aggregationErrors) {
    aggregationErrors.forEach((err, index) => {
      sheet.getCell(0 + index, 0).text(importSource);
      sheet.getCell(0 + index, 1).text(String(err.ImportStep));
      sheet.getCell(0 + index, 2).text(String(err.error_type));
      sheet.getCell(0 + index, 3).text(err.SubProductName);
      sheet.getCell(0 + index, 4).text(err.error_text);
    });
  }

  // Styling
  sheet.setColumnCount(5);
  sheet.setColumnWidth(0, 110);
  sheet.setColumnWidth(1, 110);
  sheet.setColumnWidth(2, 110);
  sheet.setColumnWidth(3, 110);
  sheet.setColumnWidth(4, 800);

  const headerArea = sheet.getRange(0, 0, 1, 5, GC.Spread.Sheets.SheetArea.colHeader);
  headerArea.hAlign(GC.Spread.Sheets.HorizontalAlign.center);
  headerArea.vAlign(GC.Spread.Sheets.VerticalAlign.center);
  headerArea.font(`bold ${FONT_SIZE}pt ${FONT_NAME}`);

  sheet.resumeEvent();
  sheet.resumePaint();
};
